export default "__VITE_ASSET__BO8x0TzJ__"